module.exports = "https://redage.akamaized.net/src/views/player/help/images/barb1.png";